import TextField from "@material-ui/core/TextField";
import AlertDialog from "components/Dialog";
import moment from "moment";
import React, { useState } from "react";
import { DateFormetContext } from "../../../../app/App.js";

const DateRange = ({ open, setOpen, ...props }) => {
  const dateFormet = React.useContext(DateFormetContext);
  const [/*error*/ setError] = useState("");
  const handleCloseDialog = () => {
    setOpen(false);
  };

  return (
    <AlertDialog
      disabled={true}
      okButtonContent="Filter"
      open={open}
      handleClose={handleCloseDialog}
      onDecline={() => {
        setOpen(false);
      }}
      onAccept={() => {
        if (props.startDate && props.endDate) {
          props.setFilter(true);
          setOpen(false);
        } else setError("Please choose a date");
      }}
      title={"Are you sure?"}
      subContent={
        <div className="p-5 w-100">
          <p className="d-flex justify-content-center"></p>
          <div className="d-flex justify-content-center pt-5">
            <div className="d-flx">
              <div className="">
                <TextField
                  defaultValue={moment(props?.startDate)
                    .utcOffset("+0100")
                    .utcOffset("+0100")
                    .format(dateFormet)}
                  className="pr-10"
                  id="date"
                  label="Start Date"
                  type="date"
                  onChange={(event) => {
                    props.setStartDate(event.target.value);
                  }}
                  sx={{ width: 220 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <TextField
                  defaultValue={moment(props?.endDate)
                    .utcOffset("+0100")
                    .format(dateFormet)}
                  id="date"
                  label="End Date"
                  type="date"
                  onChange={(event) => {
                    props.setEndDate(event.target.value);
                  }}
                  sx={{ width: 220 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default DateRange;
